import { TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { uniqBy } from 'lodash-es';
import * as api from '../../../../lib/api.js';
import { useContext } from '../../context.jsx';
import { useGrowers } from '../../../../hooks/use-growers.js';
import { useRenameContext } from './rename-context.jsx';
import { Dialog } from '../../../../components/Dialog.jsx';
import { SimpleTable } from '../../../../components/table/SimpleTable.jsx';

export function RenameDialog() {
  const { isRenaming, setRenaming } = useRenameContext();
  const { getSelectedInstances, updateInstance } = useContext();
  const instances = getSelectedInstances();
  const { selectedId: growerId } = useGrowers();
  const [newNames, setNewNames] = useState({});

  return isRenaming ? (
    <Dialog
      width="sm"
      title="Rename Instance(s)"
      canSave={Object.keys(newNames).length}
      onCancel={close}
      onSave={renameThem}
    >
      <Typography>You can rename selected instance(s) below.</Typography>
      <SimpleTable
        sx={{
          '& .MuiTableCell-head': (theme) => ({
            ...theme.typography.subtitle2,
          }),
          '& .MuiTableCell-root': {
            background: 'none',
            border: 'none',
            pl: 0,
            pb: 0,
          },
          '& .MuiTableCell-root:first-of-type': {
            width: 160,
          },
        }}
        rows={uniqBy(instances, 'id').map((instance) => ({
          'Current Name': (
            <Typography
              title={instance.name}
              sx={{
                width: 160,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'block',
              }}
            >
              {instance.name}
            </Typography>
          ),
          'New Name': buildInput(instance),
        }))}
      />
    </Dialog>
  ) : null;

  function buildInput(instance) {
    return (
      <TextField
        name={instance.id}
        size="small"
        fullWidth
        variant="filled"
        label="New Instance Name"
        onChange={updateName}
        inputProps={{ maxLength: 50 }}
        helperText="Maximum 50 characters"
      />
    );
  }

  function updateName(event) {
    const { name, value } = event.target;

    setNewNames((current) => {
      const cloned = { ...current };

      if (value) {
        cloned[name] = { name: value };
      } else {
        delete cloned[name];
      }

      return cloned;
    });
  }

  function close() {
    setNewNames({});
    setRenaming(false);
  }

  function renameThem() {
    return api
      .renameLpkInstances(growerId, newNames)
      .then(close)
      .then(() => {
        Object.entries(newNames).forEach(([id, changes]) => {
          updateInstance({ ...instances.find((i) => i.id === id), ...changes });
        });
      });
  }
}
